<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2022-09-14 19:04:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-03-27 09:51:37
-->
<template>
  <div class="wrapper">
    <div class="box">
      <el-card shadow="always">
      <div slot="header" class="clearfix">
        <span style="font-weight:bold">{{ $t('Home.List.Title') }}</span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
      </div>
      <div>
        <el-alert :title="$t('Home.List.Tip')"></el-alert>
      </div>
      <div class="search-box">
        <h4 class="titleBorder" style="margin:0;margin-top:10px">{{$t('Home.List.QuickSearch')}}</h4>
        <div class="input-box">
          
          <div class="ib1 ibdis">
            <div class="ib-title">{{$t('Home.List.MerchantName')}}:</div>
            <el-select style="width:300px" v-model="merchantValue" :filter-method="filterMet" filterable allow-create default-first-option :placeholder="$t('Home.List.MerchantNameInputTip')">
              <el-option
                v-for="(item,i) in merchantOptions"
                :key="i"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="ib2 ibdis">
            <div class="ib-title">{{$t('Home.List.PaymentCurrency')}}:</div>
            <el-select style="width:300px" v-model="paymentCurrentcyValue" filterable>
              <el-option
                v-for="(item,i) in paymentCurrentcyOptions"
                :key="i"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="ib3 ibdis">
          <el-button @click="searchHandler">{{$t('Home.List.Search')}}</el-button>
        </div>
        </div>
        <div class="search-list">
          <CollapseTransition>
          <div class="libox" v-show="isValue">
            <el-table
              :data="searchList"
              height="250"
              empty-text="No Item"
              style="width: 100%">
              <el-table-column
                prop="merchant_name"
                :label="$t('Home.List.MerchantName')">
                <template slot-scope="scope">
                <div class="cha-box">
                  <img class="img" src="../assets/select.png" alt="">
                  <div style="margin-left: 10px">{{scope.row.merchant_name}}</div>
                </div>
              </template>
              </el-table-column>
              
              <el-table-column
                prop="bin"
                :label="$t('Home.List.SuccessfulBINS')">
                <template slot-scope="scope">
                <div class="cha-box">
                  <div>{{scope.row.bin}}</div>
                </div>
              </template>
              </el-table-column>
              
            </el-table>
          </div>
          </CollapseTransition>
        </div>
        
      </div>
      <h4 class="titleBorder" style="margin:0;margin-top:10px">{{$t('Home.List.SuccessfullyPaid')}}</h4>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item,i) in binArr" :key="i" :label="item.label" :name="item.name">
          <el-table
              :data="merchantListJB"
              height="250"
              empty-text="No Item"
              v-loadmore="scrollEvent"
              ref="table"
              style="width: 100%">
              <el-table-column
                prop="merchant_name"
                :label="$t('Home.List.MerchantName')">
                <template slot-scope="scope">
                <div class="cha-box">
                  <img class="img" src="../assets/select.png" alt="">
                  <div style="margin-left: 10px">{{scope.row.merchant_name}}</div>
                </div>
              </template>
              </el-table-column>
              
              <el-table-column
                prop="currency"
                :label="$t('Home.List.SuccessfulCurrency')">
                <template slot-scope="scope">
                <div class="cha-box">
                  <div class="sl">{{scope.row.currency}}</div>
                  
                  <el-tooltip class="item" effect="dark" :content="scope.row.currency" placement="top">
                      <span style="padding:0;cursor:pointer" v-show="scope.row.currency.length > 60">...</span>
                    </el-tooltip>
                  <!-- <div class="sl">
                    <el-tooltip class="item" effect="dark" :content="scope.row.currency" placement="top">
                      <div>{{scope.row.currency}}</div>
                    </el-tooltip>
                  </div> -->
                  
                  
                </div>
              </template>
              </el-table-column>
              
            </el-table>
        </el-tab-pane>
      </el-tabs>
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="428837" name="428837">
          <div class="list-box">
            <ul>
              <li class="item" v-for="item in listData428837" :key="item.liId">
                <img class="img" :src="item.icon" alt="">
                <div class="text">{{ item.text }}</div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="222929" name="222929">
          <div class="list-box">
            <ul>
              <li class="item" v-for="item in listData222929" :key="item.liId">
                <img class="img" :src="item.icon" alt="">
                <div class="text">{{ item.text }}</div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="472593" name="472593">
          <div class="list-box">
            <ul>
              <li class="item" v-for="item in listData472593" :key="item.liId">
                <img class="img" :src="item.icon" alt="">
                <div class="text">{{ item.text }}</div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="556766" name="556766">
          <div class="list-box">
            <ul>
              <li class="item" v-for="item in listData556766" :key="item.liId">
                <img class="img" :src="item.icon" alt="">
                <div class="text">{{ item.text }}</div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
      </el-tabs> -->
    </el-card>
    </div>
  </div>
</template>

<script>
// import {  } from "element-ui"
import {searchConfirmedMerchant,getConfirmedMerchant} from '../api/request'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
export default {
  components: {CollapseTransition},
  data() {
    return {
      merchantOptions: ['FACE', 'TIKTOK', 'Google', 'Amazon', 'Lazada', 'Shopify', 'Shopee', 'Telegram', 'Apple', 'Paypal', 'Oracle', 'eBay', 'Etsy', 'Twitter'],
      merchantValue: '',
      paymentCurrentcyOptions: ['USD','GBP','HKD','MOP','CNY','KPW','VND','JPY','LAK','KHR','PHP','MYR','SGD','THP','BUK','LKR','MVR','IDR','PRK','INR','NPR','AFA','IRR','IQD','SYP',
      'LBP','SAR','KWD','BHD','QAR','OMR','YER','YDD','TRL','CYP','AUD','NZD','FJD','SBD','EUR','ISK','DKK','NOK','SEK','FIM','SUR','PLZ','CSK','HUF','DEM','ATS','CHF','NLG','BEF','LUF',
      'IEP','FRF','ESP','ITL','MTP','YUD','ROL','BGL','ALL','GRD','CAD','MXP','GTQ','SVC','HNL','NIC','CRC','PAB','CUP','BSD','JMD','HTG','DOP','TTD','BBD','COP','VEB','CYD','SRC','PES','ECS',
      'BRC','BOP','CLP','ARP','PYG','UYP','EGP','LYD','SDP','TND','DZD','MAD','MRO','XOF','GMD','GWP','GNS','SLL','LRD','GHC','NGN','XAF','GQE','ZAR','DJF','SOS','KES','UGS','TZS','RWF','BIF','ZRZ','ZMK','MCF','SCR'
      ,'MUR','ZWD','KMF', 'BRL'],
      paymentCurrentcyValue: 'USD',
      // binArr: ['472593','557271','222929','222934','428837','540524','529587','538738','526144','418122','485932','556150','404038','417969'],
      binArr: [
        {
          label: '4367**',
          name: '436797'
        },
        {
          label: '4866**',
          name: '486699'
        },
        // {
        //   label: '536025',
        //   name: '536025'
        // },
        // {
        //   label: '441112',
        //   name: '441112'
        // },
        {
          label: '4503**',
          name: '450306'
        },
        // {
        //   label: '531993',
        //   name: '531993'
        // },
        {
          label: '658706',
          name: '658706'
        },
        {
          label: '556371',
          name: '556371'
        },
        // {
        //   label: '559292',
        //   name: '559292'
        // },
        {
          label: '553370',
          name: '553370'
        },
        // {
        //   label: '404038',
        //   name: '404038'
        // },
        {
          label: '524897',
          name: '524897'
        },
        {
          label: '553437',
          name: '553437'
        },
        {
          label: '556167',
          name: '556167'
        },
        {
          label: '544923',
          name: '544923'
        },
        {
          label: '527375',
          name: '527375'
        },
        {
          label: '558325',
          name: '558325'
        },
        {
          label: '545020',
          name: '545020'
        },
      ],
      searchList: [],
      merchantList: [],
      merchantListJB: [],
      isValue: false
      // activeName: "428837",
    };
  },
  watch: {
    // activeName() {
    //   this.activeName = this.$route.query.bin || "428837"
    // }
  },
  computed: {
    // activeName() {
    //   let q = this.$route.query.bins
    //   if(q == undefined || q == "") {
    //     return "428837"
    //   }else {
    //     return q
    //   }
    // },
    activeName: {
      get() {
        let q = this.$route.query.bins
        if(q == undefined || q == "") {
          return "472593"
        }else {
          return q
        }
      },
      set(v) {
        console.log("vvv==>", v)
      }
    },
    listData428837() {
      let ldata = [
        {
          liId: 0,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.AmazonUSPayment')
        },
        {
          liId: 1,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.AmazonUKPayment')
        },
        {
          liId: 2,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.AmazonGERPayment')
        },
        {
          liId: 3,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.EBayPayment')
        },
        {
          liId: 4,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.EstyPurchasePayment')
        },
        {
          liId: 5,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.GoolgePlayPayment')
        },
        {
          liId: 6,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.PayAtShopee')
        },
        {
          liId: 7,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.GoogleAdsPayment')
        },
        {
          liId: 8,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.FacebookAdsPayment')
        },
        {
          liId: 9,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.KindlePayment')
        },
        {
          liId: 10,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.WalmartPayment')
        },
        {
          liId: 11,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.PayPalBainding')
        },
        {
          liId: 12,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.TaobaoPayment')
        },
        {
          liId: 13,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin428837.AliexpressPayment')
        }
      ]
      return ldata
    },
    listData222929() {
      let ldata = [
        {
          liId: 0,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.AmazonUSPayment')
        },
        {
          liId: 1,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.AmazonUKPayment')
        },
        {
          liId: 2,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.AmazonGERPayment')
        },
        {
          liId: 3,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.EBayPayment')
        },
        {
          liId: 4,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.EstyPurchasePayment')
        },
        {
          liId: 5,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.GoolgePlayPayment')
        },
        {
          liId: 6,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.AlipayHKBindingAndPayAtHKTVmall')
        },
        {
          liId: 7,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.WechatBindingAndPayment')
        },
        {
          liId: 8,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.BestBuyUSAPaymentWithAnyBillingAddress')
        },
        {
          liId: 9,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.PayAtNIKEWithAnyBillingAddress')
        },
        {
          liId: 10,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.PayAtAdidasHKSite')
        },
        {
          liId: 11,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.PayAtFordeal')
        },
        {
          liId: 12,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.PayAtShopee')
        },
        {
          liId: 13,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.GoogleAdsPayment')
        },
        {
          liId: 14,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.FacebookAdsPayment')
        },
        {
          liId: 15,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.TelegramPremiumPayment')
        },
        {
          liId: 16,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.TaobaoPayment')
        },
        {
          liId: 17,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.AliexpressPayment')
        },
        {
          liId: 18,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.PayPalPainding')
        },
        {
          liId: 19,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.LazadaPayment')
        },
        {
          liId: 20,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin222929.AppleUS')
        }
      ]
      return ldata
    },
    listData472593() {
      let ldata = [
        {
          liId: 0,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.EstyPurchasePayment')
        },
        {
          liId: 1,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.EBayPayment')
        },
        {
          liId: 2,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.GoogleAdsPayment')
        },
        {
          liId: 3,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.FacebookAdsPayment')
        },
        {
          liId: 4,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.AIRBNBPayment')
        },
        {
          liId: 5,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.AmazonUSPayment')
        },
        {
          liId: 6,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.GoolgePlayPayment')
        },
        {
          liId: 7,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.ShopeePay')
        },
        {
          liId: 8,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin472593.TelegramPremiumHongKong')
        }
      ]
      return ldata
    },
    listData556766() {
      let ldata = [
        {
          liId: 1,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.AmazonPayment')
        },
        {
          liId: 2,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.AliExpressPayment')
        },
        {
          liId: 3,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.eBayPayment')
        },
        {
          liId: 4,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.MercariPayment')
        },
        {
          liId: 5,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.EtsyPayment')
        },
        {
          liId: 6,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.PoshMarkPayment')
        },
        {
          liId: 7,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.AlibabaPayment')
        },
        {
          liId: 8,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.WalmartPayment')
        },
        {
          liId: 9,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.FacebookAdsPayment')
        },
        {
          liId: 10,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.TikTokAdsPayment')
        },
        {
          liId: 11,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.GoogleAdsPayment')
        },
        {
          liId: 12,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.PinterestAdsPayment')
        },
        {
          liId: 13,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.SupremePayment')
        },
        {
          liId: 14,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.FootLockerPayment')
        },
        {
          liId: 15,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.YezzyPayment')
        },
        {
          liId: 16,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.NikePayment')
        },
        {
          liId: 17,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.FootactionPayment')
        },
        {
          liId: 18,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.GooglePlayPayment')
        },
        {
          liId: 19,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.AppleStorePayment')
        },
        {
          liId: 20,
          icon: require("../assets/select.png"),
          text: this.$t('Home.List.Bin556766.NetflixPayment')
        }
      ]
      return ldata 
    }
  },
  created() {
    console.log("evn==>", process.env.NODE_ENV)
    // this.searchMethod()
    // 从前台创建卡进入执行的方法
    this.getMerchant(this.activeName)
  },
  mounted() {
    // this.handerScroll()
    console.log('this.$refs.table', this.$refs.table[0])
    // let dom = this.$refs.table[0].bodyWrapper
    // console.log("dom==>", dom)
    //   dom.addEventListener("scroll", () => {
    //     console.log('123')
    //     if(dom.scrollTop + dom.clientHeight == dom.scrollHeight) {
       
    //       this.scrollEvent()
    //     }
    //   })
  },
  directives: {
    'loadmore': {
      bind(el, binding) {
        const selectWrap = el.querySelector('.el-table__body-wrapper')
      selectWrap.addEventListener('scroll', () => {
        let sign = 0
        const scrollDistance = selectWrap.scrollHeight - selectWrap.scrollTop - selectWrap.clientHeight
        if (scrollDistance <= sign) 
          binding.value()
      }  
      )
      }
      
    }, 
    
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      this.getMerchant(tab.name)
    },
    filterMet(e) {
      this.merchantValue = e
    },
    searchHandler() {
      this.searchMethod()
    },
    // 搜索方法
    searchMethod() {
      if(this.merchantValue == '') {
        return
      }
      this.searchList = []
      this.isValue = false
      let data = {
        type: 'search_confirmed_merchant',
        // uid: '9322',//通過地址欄傳值
        uid: this.$route.query.uid,
        merchant_name: this.merchantValue,
        currency: this.paymentCurrentcyValue
      }
      searchConfirmedMerchant(data).then((res) => {
        console.log('res==>', res)
        if(res.code == 200) {
          this.isValue = true
          this.searchList = res.data
        }else {
          this.isValue = false
        }
        
      })
    },
    // handerScroll() {
      
      
    // },
    // 加载更多
    scrollEvent() {
      // 全部数据
      let copy = this.merchantList
      // 这是当前列表显示的数据
      let resu = this.merchantListJB
      // 如果当显示的数据和全部数据相同时，不再继续执行
      if(resu.length == copy.length) return
      // 计算 总数据可以分为几个50，向上取整
      let count = Math.ceil(copy.length / 20)
      // 计算当前数据可以分为几个20，向上取整
      let currentCount = Math.ceil(resu.length / 20)
      // 若即将加载的数据已经为最后一次加载 那么会出现剩余未加载的数据不足20 这时取实际长度
      let leg = currentCount + 1 == count ? copy.length : (currentCount + 1) * 20
      console.log("222")
      // 两个数据 对 20 的倍数相等 证明数据全部加载 不再往下走
      if(currentCount < count) {
        // this.$loading(true)
        console.log('333')

        setTimeout(() => {
          for(var i = currentCount * 20; i<= leg -1; i++) {
            this.merchantListJB.push(copy[i])
          }
          // this.$loading(false)
        }, 300)
      }

    },
    // 请求获取商户
    getMerchant(bin) {
      this.merchantList = []
      this.merchantListJB = []
      let data = {
        type: 'get_confirmed_merchant',
        // uid: '9322',
        uid: this.$route.query.uid,
        bin: bin
      }
      getConfirmedMerchant(data).then((res) => {
        console.log('merchant===>', res)
        res.data.forEach((item) => {
          if(this.merchantListJB.length < 20) {
            this.merchantListJB.push(item)
          }
            // this.merchantList = res.data
            this.merchantList.push(item)
        })
        
      })
    }
  },
};
</script>

<style scoped>
.titleBorder{
  border-left: 5px solid #00BEAC;
  padding-left: 2px;
}
.sl{
  width: 460px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cha-box{
  display: flex;
  align-items: center;
}
.con-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
li{
  list-style: none;
}
.libox{
  background: #F4F4F5;
}
.header-box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px 0;
}
.input-box{
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0;
}
.ibdis{
  display: flex;
  align-items: center;
}
.ib2{
  margin-left: 20px;
}
.ib3{
  margin-left: 20px;
}
.ib-title{
  margin-right: 10px;
}
.box{
  width: 80%;
  margin: 1rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.list-box{
  width: 399px;
  margin: 0 auto;
}
.img{
  width: 22px;
  height: 22px;
  display: block;
}
.item{
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.text{
  margin-left: 120px;
  color: #42474d;
  font-size: 14px;
  font-weight: bold;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
ul{
  padding: 0;
}
</style>